import { render, staticRenderFns } from "./PagePaymentError.vue?vue&type=template&id=1735950e&scoped=true&"
import script from "./PagePaymentError.vue?vue&type=script&lang=js&"
export * from "./PagePaymentError.vue?vue&type=script&lang=js&"
import style0 from "./PagePaymentError.vue?vue&type=style&index=0&id=1735950e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735950e",
  null
  
)

export default component.exports